/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Situationaddagreement2Inputs */

const en_situationaddagreement2 = /** @type {(inputs: Situationaddagreement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a contract or quote to anchor the agreement`)
};

const pt_situationaddagreement2 = /** @type {(inputs: Situationaddagreement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione o contrato ou orçamento para fixar o acordo`)
};

/**
* | output |
* | --- |
* | "Add a contract or quote to anchor the agreement" |
*
* @param {Situationaddagreement2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const situationaddagreement2 = /** @type {((inputs?: Situationaddagreement2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Situationaddagreement2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_situationaddagreement2(inputs)
	return pt_situationaddagreement2(inputs)
});
export { situationaddagreement2 as "situationAddAgreement" }